// Format file size
export const formatFileSize = (bytes) => {
  const num = parseFloat(bytes);
  if (!num || isNaN(num) || num <= 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(num) / Math.log(k));

  return Math.round(num / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

// Get file icon based on mime type
export const getFileIcon = (mimeType) => {
  if (!mimeType) return 'InsertDriveFile';

  if (mimeType.includes('pdf')) return 'PictureAsPdf';
  if (mimeType.includes('word') || mimeType.includes('document')) return 'Description';
  if (mimeType.includes('sheet') || mimeType.includes('excel')) return 'GridOn';
  if (mimeType.includes('image')) return 'Image';
  if (mimeType.includes('video')) return 'VideoFile';
  if (mimeType.includes('audio')) return 'AudioFile';
  if (mimeType.includes('zip') || mimeType.includes('rar')) return 'FolderZip';
  if (mimeType.includes('text')) return 'TextSnippet';

  return 'InsertDriveFile';
};

// Validate file type
export const isValidFileType = (file, allowedTypes) => {
  return allowedTypes.includes(file.type);
};

// Validate file size
export const isValidFileSize = (file, maxSize) => {
  return file.size <= maxSize;
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;

  return date.toLocaleDateString('id-ID', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Truncate text
export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Get file extension
export const getFileExtension = (filename) => {
  if (!filename) return '';
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
};

// Check if file is image
export const isImage = (mimeType) => {
  return mimeType && mimeType.startsWith('image/');
};

// ============================================
// NEW: Admin Helper Functions
// ============================================

// Check if user is admin
export const isAdmin = (user) => {
  if (!user) return false;
  return user.role === 'admin';
};

// Get user role
export const getUserRole = (user) => {
  if (!user) return 'guest';
  return user.role || 'user';
};

// Check if user has permission
export const hasPermission = (user, permission) => {
  if (!user) return false;
  if (isAdmin(user)) return true; // Admin has all permissions

  // Add more permission checks here if needed
  return false;
};

// Get role badge color
export const getRoleBadgeColor = (role) => {
  switch (role) {
    case 'admin':
      return 'error'; // Red
    case 'user':
      return 'primary'; // Blue
    default:
      return 'default'; // Gray
  }
};

// Get role display name
export const getRoleDisplayName = (role) => {
  switch (role) {
    case 'admin':
      return 'Administrator';
    case 'user':
      return 'User';
    default:
      return 'Guest';
  }
};